import {
  SUBMIT_MULTI_ASK,
  SET_ERROR_MSG,
  SET_SUCCESS,
  RESET_MULTI_ASK,
} from './actions';

const initialState = {
  isSubmitting: false,
  isSuccess: false,
  errorMsg: undefined,
};

export function multiAskStatus(
  state = initialState,
  { type, payload }: any = {},
) {
  switch (type) {
    case SUBMIT_MULTI_ASK: {
      return {
        errorMsg: undefined,
        isSuccess: false,
        isSubmitting: true,
      };
    }

    case SET_ERROR_MSG: {
      const { errorMsg } = payload;
      return {
        isSubmitting: false,
        isSuccess: false,
        errorMsg,
      };
    }

    case SET_SUCCESS: {
      return {
        isSubmitting: false,
        isSuccess: true,
        errorMsg: undefined,
      };
    }

    case RESET_MULTI_ASK:
      return initialState;
    default:
      return state;
  }
}
